var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.11492 0L18.5622 24.6645L0 44.7185H4.17882L20.4316 27.1618L33.5622 44.7185H47.7803L28.296 18.6666L45.5746 0H41.3957L26.4294 16.1693L14.3358 0H0.117691H0.11492ZM6.2584 3.07746H12.7887L41.6312 41.641H35.1009L6.2584 3.07746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/IconTwitter.4b720c7fd9d69ce74788c490a7850637.svg";
export { ForwardRef as ReactComponent };